<template>
    <flex-element
        class="f-relative"
        :class="bgClasses"
        :exclude-classes="excludedClassGroups"
        :element-type="elementType"
    >
        <div class="fu-placement-fill f-z-1" :style="renderGradientStyles" />
        <!-- do not delete this <div>, it's needed for the aspect ratio option to work -->
        <div
            class="f-overflow-hidden f-h-1/1"
            :class="[classWrapper, imageContainerClasses, bgWrapperClasses]"
            data-image-wrapper
        >
            <img
                v-lazy="src"
                :alt="alt"
                class="f-w-1/1 f-h-1/1"
                :class="[classImage, imageClasses]"
                :filter="filterStyle"
                data-image
            >
        </div>
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-dumb';
import { getClassDefinition } from '@/utils/tailwind-helper';
import { gradientStyleByElement, opacityStyleByElement } from '@/utils/css';

export default {
    name: 'a-image',
    mixins: [baseAtom],

    props: {
        width: {
            type: String,
            default: '',
        },

        height: {
            type: String,
            default: '',
        },

        src: {
            type: String,
            default: '',
        },

        alt: {
            type: String,
            default: '',
        },

        classWrapper: {
            type: String,
            default: '',
        },

        classImage: {
            type: String,
            default: '',
        },
    },

    computed: {
        isBackgroundImage() {
            return this.hasElementData('is-background-image');
        },

        excludedClassGroups() {
            // using Set to strip out any duplicate classes
            return Array.from(new Set([...this.imageContainerClassGroups, ...this.imageClassGroups]));
        },

        renderGradientStyles() {
            return {
                ...gradientStyleByElement(this),
                ...opacityStyleByElement(this),
            };
        },

        filterStyle() {
            return {
                filter: this.getElementData('filter'),
            };
        },

        imageContainerClassGroups() {
            return ['borderRadius'];
        },

        imageClassGroups() {
            if (this.isBackgroundImage) {
                return [
                    'height',
                    'objectFit',
                    'objectPosition',
                    'placement',
                    'maxHeight',
                    'maxWidth',
                    'minHeight',
                    'minWidth',
                    'transformOrigin',
                    'width',
                ];
            }

            return [
                'objectFit',
                'objectPosition',
            ];
        },

        imageContainerClasses() {
            return this.htmlClass.filter((className) => {
                const { tailwindDefinitionProp } = getClassDefinition(className);

                return this.imageContainerClassGroups.includes(tailwindDefinitionProp);
            });
        },

        imageClasses() {
            const classes = this.htmlClass.filter((className) => {
                const { tailwindDefinitionProp } = getClassDefinition(className);

                return this.imageClassGroups.includes(tailwindDefinitionProp);
            });

            if (this.isBackgroundImage) {
                classes.push('f-h-1/1');
            }

            return classes;
        },

        bgClasses() {
            if (!this.isBackgroundImage) return [];

            return ['fu-placement-fill'];
        },

        bgWrapperClasses() {
            if (!this.isBackgroundImage) return '';

            return ['fu-placement-fill', 'f--z-1'];
        },
    },
};
</script>
